import { Observable } from "rxjs";

import { st, OrdersRepository, ProductScheduleSlotsRepository } from "lib/index";
import { createFormInstance, createResourceInstance } from "modules/utils/index";

export const OPEN = "orders/ChangeOrderScheduleSlotModal/OPEN";
export const CLOSE = "orders/ChangeOrderScheduleSlotModal/CLOSE";
export const FETCH_SLOTS_DATA = "orders/ChangeOrderScheduleSlotModal/FETCH_SLOTS_DATA";
export const FETCH_SLOTS_DATA_START = "orders/ChangeOrderScheduleSlotModal/FETCH_SLOTS_DATA_START";
export const FETCH_SLOTS_DATA_SUCCESS = "orders/ChangeOrderScheduleSlotModal/FETCH_SLOTS_DATA_SUCCESS";
export const FETCH_SLOTS_DATA_FAILURE = "orders/ChangeOrderScheduleSlotModal/FETCH_SLOTS_DATA_FAILURE";
export const INITIALIZE_ORDER = "orders/ChangeOrderScheduleSlotModal/INITIALIZE_ORDER";
export const UPDATE_ORDER = "orders/ChangeOrderScheduleSlotModal/UPDATE_ORDER";
export const VALIDATE = "orders/ChangeOrderScheduleSlotModal/VALIDATE";
export const SUBMIT = "orders/ChangeOrderScheduleSlotModal/SUBMIT";
export const FETCH_SUBMIT_START = "orders/ChangeOrderScheduleSlotModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "orders/ChangeOrderScheduleSlotModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "orders/ChangeOrderScheduleSlotModal/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.orders.ChangeOrderScheduleSlotModal;

const slotsDataInstance = createResourceInstance({
  FETCH: FETCH_SLOTS_DATA,
  FETCH_START: FETCH_SLOTS_DATA_START,
  FETCH_SUCCESS: FETCH_SLOTS_DATA_SUCCESS,
  FETCH_FAILURE: FETCH_SLOTS_DATA_FAILURE,
  stateSelector,
  stateKey: "slotsData",
  getModel: ({ form: { model: order } }) => {
    if (order.product_variant) {
      return ProductScheduleSlotsRepository.findAll({
        product_variant_id: order.product_variant.id,
      });
    } else {
      return Observable.of([]).delay(0);
    }
  },
});

const formInstance = createFormInstance({
  INITIALIZE_MODEL: INITIALIZE_ORDER,
  UPDATE_MODEL: UPDATE_ORDER,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "form",
  validate: ({ form: { model: order } }, errors, { submitValidate }) => {
    const slot = order.product_schedule_slot;
    if (slot && !slot.id) {
      submitValidate && errors.add(`order.product_schedule_slot.start_date`, st.validators.presence(slot.start_date));
      submitValidate && errors.add(`order.product_schedule_slot.end_date`, st.validators.presence(slot.end_date));
      if (slot.start_time || slot.end_time) {
        submitValidate && errors.add(`order.product_schedule_slot.start_time`, st.validators.presence(slot.start_time));
        submitValidate && errors.add(`order.product_schedule_slot.end_time`, st.validators.presence(slot.end_time));
      }
      submitValidate &&
        slot.starts_at &&
        slot.ends_at &&
        errors.add(
          `order.product_schedule_slot.end_time`,
          st.validators.range(new Date(slot.ends_at), { greater_than_or_equal_to: new Date(slot.starts_at) })
        );
    }
  },
  submitModel: ({ form: { model: order } }, store) => {
    return OrdersRepository.changeScheduleSlot(order);
  },
});

const initialState = {
  opened: false,
  form: formInstance.initialState,
  slotsData: slotsDataInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,
  ...slotsDataInstance.reducersMap,

  [OPEN]: () => ({
    ...initialState,
    opened: true,
  }),

  [CLOSE]: (state) => ({
    ...state,
    opened: false,
  }),
};

const epics = [
  ...formInstance.epics,
  ...slotsDataInstance.epics,

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(close()),
];

export const { fetch: fetchSlotsData } = slotsDataInstance.actions;
export const { initializeModel: loadOrder, updateModel: updateOrder, validate, submit } = formInstance.actions;

export function open(order) {
  return (dispatch) => {
    dispatch({ type: OPEN });
    dispatch(loadOrder(order));
    dispatch(fetchSlotsData());
  };
}

export function close() {
  return { type: CLOSE };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/ChangeOrderScheduleSlotModal/index.js